import { Component, OnInit } from '@angular/core';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import * as colabInter from 'app/main/pagina/encuestador-n35/colaboradores35/colaboradores35.interface';

import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-norm35-step9',
  templateUrl: './norm35-step9.component.html',
  styleUrls: ['./norm35-step9.component.scss']
})
export class Norm35Step9Component implements OnInit {
  dataLink = [
    {
      idLink: "91",
      name  : '9.1 El patrón tendrá la opción de contratar una unidad de verificación acreditada ',
      ruta : './step9-sub1'
    },{
      idLink: "92",
      name : '9.2 Las unidades de verificación que evalúen la conformidad con la presente Norma',
      ruta : './step9-sub2'
    },{
      idLink: "93",
      name  : '9.3 Las unidades de verificación acreditadas y aprobadas que evalúen el cumplimiento con esta Norma',
      ruta : './step9-sub3'
    },{
      idLink: "94",
      name  : '9.4 La vigencia de los dictámenes emitidos por las unidades de verificación será de dos años  ',
      ruta : './step9-sub4'
    }
  ]
  productoCertificar: backInter.prodNorma35;
  typeMenu=false;
  idiomaBanner:any;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
   }

  ngOnInit() {
    this.obtieneCertificarActual();
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
  }

  cambiaIdiomaBanner(idioma:string){
    this.idiomaBanner = this.translateSrv.currentLang;
    switch(idioma){
      case 'es': this.idiomaBanner = idioma;
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-25.png';
  }

  obtieneCertificarActual(){
    this.wizardService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
        prodsCertificar.forEach( (producto) => {
          let fecha = producto.fechaNorma35;
          let idProducto = producto.idNorma35;
          console.log('productoID',localStorage.getItem('productoID'));
          console.log('fechaNorma',localStorage.getItem('FechaNorma'));
          if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
          if(producto.completoNorma35 === 1){
            this.productoCertificar = producto;
            throw BreakException;
          }
        }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      this.getColaboradoresFast();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getColaboradoresFast(){
    this.wizardService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
    .subscribe( (getFast: colabInter.getBDFast) => {
      if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
        if(getFast.numeroColaboradores<=50){
          console.log("Menos de 50");
          this.typeMenu=false;
        }else{
          console.log("Más de 50");
          this.typeMenu=true;
        }
      }
    });
  }

}
